"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Footer", {
  enumerable: true,
  get: function () {
    return _logged2.default;
  }
});
Object.defineProperty(exports, "Header", {
  enumerable: true,
  get: function () {
    return _logged.default;
  }
});
Object.defineProperty(exports, "Menu", {
  enumerable: true,
  get: function () {
    return _menu.default;
  }
});
var _logged = _interopRequireDefault(require("webmotors-react-pj/frame/header/logged"));
var _logged2 = _interopRequireDefault(require("webmotors-react-pj/frame/footer/logged"));
var _menu = _interopRequireDefault(require("webmotors-react-pj/frame/menu"));